import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck, Facebook, Instagram, Linkedin } from "lucide-react";
import { COMPANY } from "@/data/mockData";

const siteLogoPath = "/logo/gitlogo.jpg";

export default function Footer() {
  return (
    <footer className="bg-[#0A2540] text-slate-300 mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="mb-4">
            <img
              src={siteLogoPath}
              alt="Gippsland Institute of Technology"
              className="h-12 w-auto rounded-md bg-white px-2 py-1 object-contain"
            />
          </div>
          <p className="text-sm leading-relaxed mb-4">{COMPANY.legal}</p>
          <div className="flex items-center gap-2 text-xs text-emerald-300 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-3 py-1 w-fit">
            <ShieldCheck className="w-3.5 h-3.5" /> WorkSafe VIC approved
          </div>
        </div>

        <div>
          <div className="text-white font-display font-semibold mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/course" className="hover:text-orange-300">White Card Course</Link></li>
            <li><Link to="/calendar" className="hover:text-orange-300">Course Calendar</Link></li>
            <li><Link to="/locations" className="hover:text-orange-300">Locations</Link></li>
            <li><Link to="/faq" className="hover:text-orange-300">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-display font-semibold mb-4">Student</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/login" className="hover:text-orange-300">Student Login</Link></li>
            <li><Link to="/student/certificates" className="hover:text-orange-300">Certificates</Link></li>
            <li><Link to="/admin/login" className="hover:text-orange-300">Admin Login</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-display font-semibold mb-4">Get in touch</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-orange-400" /><a href={`tel:${COMPANY.phone}`} className="hover:text-orange-300">{COMPANY.phone}</a></li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-orange-400" /><a href={`mailto:${COMPANY.email}`} className="hover:text-orange-300">{COMPANY.email}</a></li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-orange-400" /><span>4/70 Main Street, Pakenham, Melbourne, Victoria, Australia 3810</span></li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-orange-400" /><span>North Melbourne Campus - 15-17 Racecourse Rd NORTH MELBOURNE VIC 3051</span></li>

          </ul>
          <div className="flex gap-3 mt-5">
            <a href="#" className="w-9 h-9 rounded-md bg-white/5 hover:bg-orange-500 flex items-center justify-center transition-colors" aria-label="Facebook"><Facebook className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-md bg-white/5 hover:bg-orange-500 flex items-center justify-center transition-colors" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-md bg-white/5 hover:bg-orange-500 flex items-center justify-center transition-colors" aria-label="LinkedIn"><Linkedin className="w-4 h-4" /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-xs text-slate-400">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-2">
          <div>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved. ABN {COMPANY.abn}</div>
          <div className="flex gap-4">
            <a href="#" className="hover:text-orange-300">Privacy</a>
            <a href="#" className="hover:text-orange-300">Terms</a>
            <a href="#" className="hover:text-orange-300">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
